import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { z  } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import Form from 'react-bootstrap/Form';

import "./adminChangePassword.css";
import { clearData } from '../../../utils/localStorage';
import { ChangePasswordService } from '../../../modules/services';
import { sidebarNavItems, ROUTES, MESSAGE } from "../../../constant";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import TextInputField from '../../commanComponents/textInputField/textInputField';
import SideBar from "../../commanComponents/sidebar/sidebar";
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';


const AdminChangePassword = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const loginSchema = z.object({
        //password
        password: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Password") }),
        //new_password
        new_password: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "New Password") }),
        //confirm_password
        confirm_password: z.string().min(1, { message: MESSAGE.REQUEIRED_THIS_FIELD.replace("{0}", "Confirm Password") }),
    }).refine((data) => data.new_password === data.confirm_password, {
        message: MESSAGE.CONFIRM_PASSWORD_INVALID,
        path: ["confirm_password"]
    });

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: zodResolver(loginSchema)
    });
    

    const handleChangePasswordSave = (passwordData) => { 
            setIsLoading(true);

            (async () => {
                const responseData = await ChangePasswordService(passwordData, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                    navigate(ROUTES.ADMIN_PROFILE);
                }
                else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                }
                else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            })();
        // }
    }

    return (
        <div className='change-password-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='change-password-side-container'>
                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row change-password-filter-container'>
                </div>
                
                <div className='change-password-main-container'>
                    <Form onSubmit={handleSubmit(handleChangePasswordSave)}>
                        <div className='row'>
                            <div className='col'>
                            <h5>Change Password</h5>
                            </div>
                            <div className='col change-password-header-right'>
                                <PrimaryButton
                                    text="Save"
                                    isLoading={isLoading}
                                    type="submit"
                                />
                            </div>
                        </div>
                        
                        <hr className="change-password-border" />
                        <div className='row change-password-input-div'>
                            <TextInputField
                                placeholder="Old Password"
                                fieldType="password"
                                errorMessage={errors.password?.message}
                                inputKey="password"
                                formRegister={register}
                            />
                            <TextInputField
                                placeholder="New Password"
                                fieldType="password"
                                errorMessage={errors.new_password?.message}
                                inputKey="new_password"
                                formRegister={register}
                            />
                            <TextInputField
                                placeholder="Confirm Password"
                                fieldType="password"
                                errorMessage={errors.confirm_password?.message}
                                inputKey="confirm_password"
                                formRegister={register}
                            />
                        </div>
                        <br />
                    </Form>
                </div>
            </div>
        </div>
    );
 }


export default AdminChangePassword;
